import React, { Fragment, useState, useEffect, useContext } from "react";
import moment from "moment";
import VacationList from "./vacationlist";
import ViewLogs from "../ViewLogs";
import "../myschedule.scss";
import useDisableHelp from "../../../../Hooks/useDisableHelp";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import { MY_VACATIONS } from "../Constants";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import MyScheduleFeesContext from "../MyScheduleFeesContext";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import C2CMiddlePopup from "../../../common/Popups/C2CMiddlePopup";
import successTickImg from "../../../../assets/success_tick.svg";
import {
  CREATE_CLINIC_VACATION,
  CREATE_DOCTOR_VACATION,
  DELETE_CLINIC_VACATION,
  DELETE_DOCTOR_VACATION,
  EDIT_CLINIC_VACATION,
  EDIT_DOCTOR_VACATION,
  GET_CLINIC_PROCEDURE,
  GET_CLINIC_VACATION,
  GET_DOCTOR_PROCEDURE,
  GET_DOCTOR_VACATION,
} from "../MyScheduleFeesApiHandler/apiConstants";
import VacationCalendar from "./vacationCalendar";
import deleteIcon from "../../../../assets/delete_with_background.svg";
import warningImg from "../../../../assets/warning_red.svg";
import errorIcon from "../../../../assets/red_close.png";
import Loader from "../../../UI Component/Loader/Loader";
import { USER_ROLE } from "../../../../Util/constants";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const VacationsDays = (props) => {
  const { staffDoctor } = props;

  const doctor_context = useContext(DoctorContext);
  useDisableHelp();
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const myScheduleFeesContext = useContext(MyScheduleFeesContext);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  const [dateState, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
    },
  ]);
  const [vacations, setVacations] = useState([]);
  const [addClass, setAddClass] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [vacationErrorMessage, setVacationErrorMessage] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [confirmButton, setConfirmButton] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [openVacationPopup, setOpenVacationPopup] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [updateVacationId, setUpdateVacationId] = useState("");
  const [showCancelAppointmentPopup, setShowCancelAppointmentPopup] =
    useState(false);
  const [numberOfAppointments, setNumberOfAppointments] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Lifecycle Methods ===>

  useEffect(() => {
    getProcedure("");
  }, []);

  useEffect(() => {
    getVacations();
    setShowLoader(true);
  }, [doctor_context?.clinic_id, staffDoctor?.id]);

  // <===

  // Helper Methods ===>

  // <===

  // Api Calls ===>

  const getProcedure = (procedure_id) => {
    let url = GET_DOCTOR_PROCEDURE;
    let payload = {
      doctor_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
    };

    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      payload.doctor_id =
        doctorRole == USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        userType == APPLICABLE_ROLE.STAFF
          ? staffDoctor?.id
          : userId;
      payload.clinic_id = doctor_context?.clinic_id;
      url = GET_CLINIC_PROCEDURE;
    }

    let resData = c2cPostApiHandler(url, payload);
    resData.then(([res, err]) => {
      if (!err) {
        let arr = [...myScheduleFeesContext.consultationTypes];
        if (res.data.statusCode == 200) {
          if (res.data.procedure_details.length > 0) {
            res.data.procedure_details.map((ele) => {
              ele["value"] = ele.id;
              ele["id"] = "4";
              ele["label"] = ele.procedure_name;
              arr.push(ele);
            });
            setDropdownOptions(arr);
            if (procedure_id != "") {
              let findValue = arr.find((data) => data.value == procedure_id);
              findValue = findValue ? findValue : arr[0];
              findValue &&
                myScheduleFeesContext.setSelectedConsultationType({
                  id: "4",
                  value: procedure_id,
                  label:
                    procedure_id == "4"
                      ? findValue.label
                      : findValue.procedure_name,
                });
            }
          }
        } else {
          setDropdownOptions(arr);
        }
      }
    });
  };

  const getVacations = () => {
    setVacationErrorMessage(false);
    setConfirmButton(false);

    let url = GET_DOCTOR_VACATION;
    let payload = {
      doctor_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
    };

    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      payload.doctor_id =
        doctorRole == USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        userType == APPLICABLE_ROLE.STAFF
          ? staffDoctor?.id
          : userId;
      payload.clinic_id = doctor_context?.clinic_id;
      url = GET_CLINIC_VACATION;
    }

    let resData = c2cPostApiHandler(url, payload);
    resData.then(([res, err]) => {
      setShowLoader(false);
      if (!err) {
        if (res.data && res.data.message === "no vacations found") {
          let temp = [];
          setVacations(temp);
        } else {
          setVacations(res.data.data);
        }
      }
    });
  };

  const handleConfirm = (cancelAppointments) => {
    let url = CREATE_DOCTOR_VACATION;
    let payload = {
      doctor_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
      start_date: moment(dateState[0].startDate).format("YYYY-MM-DD"),
      end_date: moment(dateState[0].endDate).format("YYYY-MM-DD"),
      user_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
      user_type:
        userType === APPLICABLE_ROLE.DOCTOR
          ? 1
          : userType === APPLICABLE_ROLE.STAFF && 4,
      cancel_existing_appointments: cancelAppointments,
    };

    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      payload.doctor_id =
        doctorRole == USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        userType == APPLICABLE_ROLE.STAFF
          ? staffDoctor?.id
          : userId;
      payload.clinic_id = doctor_context?.clinic_id;
      url = CREATE_CLINIC_VACATION;
    }

    let resData = c2cPostApiHandler(url, payload);
    resData.then(([res, err]) => {
      if (!err) {
        setLoading(false);
        setShowLoader(false);
        setVacationErrorMessage(false);
        setConfirmButton(false);
        setOpenVacationPopup(false);
        setShowCancelAppointmentPopup(false);
        setNumberOfAppointments("");
        if (res.data.errorCode === 503) {
          setShowErrorPopup(true);
          setErrorMsg(res.data?.message);
        } else if (res.data.errorCode === 502) {
          setShowCancelAppointmentPopup(res.data?.active_appointments_exists);
          setNumberOfAppointments(res.data?.active_appointment_count);
        } else if (res.data.errorCode === 501) {
          setVacationErrorMessage(true);
        } else if (res.data.statusCode === 200) {
          setOpenVacationPopup(true);
          getVacations();
        }
      }
    });
  };

  const deleteVacation = () => {
    handleCloseDeletePopup();
    setShowLoader(true);

    let url = DELETE_DOCTOR_VACATION;
    let payload = {
      doctor_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
      vacation_slot_id: deleteId,
      user_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
      user_type:
        userType === APPLICABLE_ROLE.DOCTOR
          ? 1
          : userType === APPLICABLE_ROLE.STAFF && 4,
    };

    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      payload.doctor_id =
        doctorRole == USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        userType == APPLICABLE_ROLE.STAFF
          ? staffDoctor?.id
          : userId;
      payload.clinic_id = doctor_context?.clinic_id;
      url = DELETE_CLINIC_VACATION;
    }

    let resData = c2cPostApiHandler(url, payload);
    resData.then(([res, err]) => {
      if (!err) {
        if (res.data.statusCode === 200) {
          setDateState([
            {
              startDate: new Date(),
              endDate: new Date(),
              rangeColors: "#F969A4",
              color: "#F969A4",
              key: "selection",
            },
          ]);
          getVacations();
        }
      }
    });
  };

  const updateVacation = (cancelAppointments) => {
    let url = EDIT_DOCTOR_VACATION;
    let payload = {
      doctor_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
      vacation_slot_id: updateVacationId,
      start_date: moment(dateState[0].startDate).format("YYYY-MM-DD"),
      end_date: moment(dateState[0].endDate).format("YYYY-MM-DD"),
      user_id: userType === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
      user_type:
        userType === APPLICABLE_ROLE.DOCTOR
          ? 1
          : userType === APPLICABLE_ROLE.STAFF && 4,
      cancel_existing_appointments: cancelAppointments,
    };

    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      payload.doctor_id =
        doctorRole == USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        userType == APPLICABLE_ROLE.STAFF
          ? staffDoctor?.id
          : userId;
      payload.clinic_id = doctor_context?.clinic_id;
      url = EDIT_CLINIC_VACATION;
    }

    let resData = c2cPostApiHandler(url, payload);
    resData.then(([res, err]) => {
      if (!err) {
        setLoading(false);
        setShowLoader(false);
        setVacationErrorMessage(false);
        setConfirmButton(false);
        setOpenVacationPopup(false);
        setShowCancelAppointmentPopup(false);
        setNumberOfAppointments("");
        if (res.data.errorCode === 503) {
          setShowErrorPopup(true);
          setErrorMsg(res.data?.message);
        } else if (res.data.errorCode === 502) {
          setShowCancelAppointmentPopup(res.data?.active_appointments_exists);
          setNumberOfAppointments(res.data?.active_appointment_count);
        } else if (res.data.errorCode === 501) {
          setVacationErrorMessage(true);
        } else if (res.data.statusCode === 200) {
          setOpenVacationPopup(true);
          getVacations();
        }
      }
    });
  };

  const handleCancelAppointments = () => {
    if (isEdit) {
      updateVacation(true);
    } else {
      handleConfirm(true);
    }
    setShowLoader(true);
  };

  // <===

  // Actions ===>

  const handleDateChange = (e) => {
    setDateState([e.selection]);
    setConfirmButton(true);
    setVacationErrorMessage(false);
  };

  const handleClosePopup = () => {
    setDateState([
      {
        startDate: new Date(),
        endDate: new Date(),
        rangeColors: "#F969A4",
        color: "#F969A4",
        key: "selection",
      },
    ]);
    setIsEdit(false);
    setShowErrorPopup(false);
    setOpenVacationPopup(false);
    setShowCancelAppointmentPopup(false);
  };

  const handleAddUpdateVacation = () => {
    if (isEdit) {
      updateVacation();
    } else {
      handleConfirm();
    }
    setLoading(true);
  };

  const editVacation = (id, start_date, end_date) => {
    setIsEdit(true);
    setUpdateVacationId(id);
    setDateState([
      {
        startDate: new Date(start_date),
        endDate: new Date(end_date),
        rangeColors: "#F969A4",
        color: "#F969A4",
        key: "selection",
      },
    ]);
    setConfirmButton(true);
  };

  const handleDeleteVacation = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const handleCloseDeletePopup = () => {
    setDeleteModal(false);
  };

  // <===

  return (
    <Fragment>
      {showLoader ? <Loader /> : null}
      <div className="container ">
        <div
          className="vacation-section"
          style={{
            display: window.innerWidth > 768 ? "flex" : "block",
            width: "100%",
          }}
        >
          <div className="vacation-left-content">
            <VacationList
              showLoader={showLoader}
              vacations={vacations}
              editVacation={editVacation}
              handleDeleteVacation={handleDeleteVacation}
            />
          </div>
          <hr className="mob-hr"></hr>
          <div className="vacation-right-content">
            <div>
              <div
                className="heading-container"
                style={{ marginBottom: "5px" }}
              >
                <div className="vacations-right-content-header">
                  Plan Vacation
                </div>
                <div
                  className="view-logs-title"
                  onClick={() => {
                    if (window.innerWidth > 767) {
                      setAddClass("btm-drawer");
                      props.setShowBackDrop("btm-drawer");
                      props.handleViewLogOpened();
                    } else {
                      props.setShowLogsMobile(true);
                    }
                  }}
                >
                  View Logs
                </div>
              </div>
              <div className="vacations-right-content-subheader">
                Plan your leaves / vacation up to 90 days in advance
              </div>
            </div>

            <VacationCalendar
              confirmButton={confirmButton}
              vacationErrorMessage={vacationErrorMessage}
              dateState={dateState}
              loading={loading}
              isEdit={isEdit}
              handleDateChange={handleDateChange}
              handleAddUpdateVacation={handleAddUpdateVacation}
            />
          </div>
        </div>
      </div>
      {showErrorPopup && (
        <C2CMiddlePopup
          openPopup={showErrorPopup}
          dialogClassName="vacation-popup"
          hideCloseIcon={true}
          title={errorMsg}
          titleImg={errorIcon}
          middleBtn="Okay"
          handleMiddleBtnClick={handleClosePopup}
        />
      )}
      {deleteModal && (
        <C2CMiddlePopup
          openPopup={deleteModal}
          dialogClassName="vacation-popup"
          hideCloseIcon={true}
          title="Delete Vacation"
          subtitle={
            <span>
              Once deleted, the period will be available for patients to book
              appointment. Do you want to delete the planned vacation?
            </span>
          }
          titleImg={deleteIcon}
          leftBtn={"Yes"}
          rightBtn={"No"}
          handleLeftBtnClick={deleteVacation}
          handleRightBtnClick={handleCloseDeletePopup}
        />
      )}
      {openVacationPopup && (
        <C2CMiddlePopup
          openPopup={openVacationPopup}
          dialogClassName="vacation-popup"
          hideCloseIcon={true}
          title={
            isEdit
              ? "Vacation has been edited and saved"
              : "Vacation added successfully"
          }
          subtitle={
            <span>
              Period{" "}
              {`${moment(dateState[0].startDate).format(
                "DD/MM/YYYY"
              )} to ${moment(dateState[0].endDate).format("DD/MM/YYYY")}`}{" "}
              will be marked as vacation in your calendar. The slots will not be
              available to patients during this period.
            </span>
          }
          titleImg={successTickImg}
          middleBtn="Okay"
          handleMiddleBtnClick={handleClosePopup}
        />
      )}
      {showCancelAppointmentPopup && (
        <C2CMiddlePopup
          openPopup={showCancelAppointmentPopup}
          dialogClassName="vacation-popup"
          title={
            <span>
              Appointment already booked in <br /> selected period
            </span>
          }
          subtitle={
            <span>
              There are{" "}
              <span style={{ fontWeight: "500" }}>{numberOfAppointments}</span>{" "}
              appointments booked in the selected period. If you proceed with
              cancel appointments, all the appointments scheduled in the
              specified period will be canceled.
            </span>
          }
          titleImg={warningImg}
          middleBtn="Cancel Appointments"
          handleMiddleBtnClick={handleCancelAppointments}
          handleClosePopup={handleClosePopup}
        />
      )}
      <ViewLogs
        addClass={addClass}
        setAddClass={() => {
          setAddClass("");
          props.setShowBackDrop("");
          props.handleViewLogOpened();
        }}
        logType={MY_VACATIONS}
        roleNameMenu={props.roleNameMenu}
        tableData={props.tableData}
        handleViewLogOnFilter={props?.handleViewLogOnFilter}
        logFilterData={props?.logFilterData}
        totalRecords={props?.totalRecords}
        selectedRadioBtn={props?.selectedRadioBtn}
        handleRadioBtn={props?.handleRadioBtn}
        procedureDropDown={dropdownOptions}
      ></ViewLogs>
    </Fragment>
  );
};
export default VacationsDays;
